/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
const upsellCartCheckbox = document.querySelector('.js-addon-product')
const showMore = document.querySelector('.js-show-more')
const full = document.querySelector('.full')
const partial = document.querySelector('.partial')
const toggle = (elem) => { 
  elem.classList.toggle('is-visible') 
}

if (showMore) {
  showMore.addEventListener('click', (evt) => {
    evt.preventDefault()
    const scrollT = window.pageYOffset;     // get current scroll position
    toggle(full)
    toggle(partial)
    toggle(showMore)
    let inner = showMore.innerHTML.trim()
    console.log(inner)
    inner == 'Read More' ? showMore.innerHTML = 'Read Less' : showMore.innerHTML = 'Read More'
    window.scrollTo(0, scrollT)
  })
}

// show navigation links once site has loaded
function showLinks() {
  $(".site-header").each(function(idx, link) {
    link.style.opacity = 1;
    link.style.height = "auto";
    link.style.display = "block";
  });
}

// move ReCharge links to the end of the mobile menu nav
function moveMobileNavLinks() {
  const mobileMenu = $("ul.navigation__links")[1];
  // move log in link to end of mobile menu
  $(".navigation__link--secondary a:contains('Log in')").parent("li").appendTo(mobileMenu);
  // move create account link to end of mobile menu
  $(".navigation__link--secondary a:contains('Create account')").parent("li").appendTo(mobileMenu);
}

// on window load
$(function() {
//   showLinks();
  moveMobileNavLinks();
});